import {createActionGroup, emptyProps} from '@ngrx/store';
import {DateOnlyIsoString, ListData} from '@aviary/store/common/common.types';
import {EditHoldValue, Hold, HOLDS_FEATURE_KEY, ReadyForPickupHolds} from '@store/holds/holds.types';
import {CatalogRecord} from '@store/catalog/catalog.types';

export const HoldsActions = createActionGroup({
  source: HOLDS_FEATURE_KEY,
  events: {
    'Load Ready For Pickup Holds': emptyProps(),
    'Load Ready For Pickup Holds Success': (data: ReadyForPickupHolds) => ({data}),
    'Load Ready For Pickup Holds Failure': (error: unknown) => ({error}),

    'Load On Hold Holds': emptyProps(),
    'Load On Hold Holds Success': (listData: ListData<Hold>) => ({listData}),
    'Load On Hold Holds Failure': (error: unknown) => ({error}),

    'Load Holds For Catalog Records': (catalogRecordIds: number[]) => ({catalogRecordIds}),
    'Load Holds For Catalog Records Success': (holds: Hold[]) => ({holds}),
    'Load Holds For Catalog Records Failure': (error: unknown) => ({error}),

    'Place Hold By Catalog Record Id': (catalogRecordId: number) => ({catalogRecordId}),
    'Place Hold Or Login': (catalogRecord: CatalogRecord) => ({catalogRecord}),
    'Prepare Place Hold': (catalogRecord: CatalogRecord) => ({catalogRecord}),
    'Show Place Hold Branch Selection': (catalogRecord: CatalogRecord) => ({catalogRecord}),
    'Place Hold': (catalogRecord: CatalogRecord, pickupBranchId: number) => ({catalogRecord, pickupBranchId}),
    'Place Hold Success': (hold: Hold) => ({hold}),
    'Place Hold Failure': (error: unknown) => ({error}),

    'Edit Hold By Catalog Record Id': (catalogRecordId: number) => ({catalogRecordId}),
    'Show Edit Hold': (hold: Hold) => ({hold}),
    'Edit Hold Branch': (hold: Hold, value: EditHoldValue) => ({hold, value}),
    'Edit Hold Pause': (hold: Hold, value: EditHoldValue) => ({hold, value}),
    'Edit Hold Success': emptyProps(),
    'Edit Hold Failure': (error: unknown) => ({error}),

    'Show Cancel Hold': (hold: Hold) => ({hold}),
    'Cancel Hold': (hold: Hold) => ({hold}),
    'Cancel Hold Success': (hold: Hold) => ({hold}),
    'Cancel Hold Failure': (error: unknown) => ({error}),

    'Show Pause All Holds': emptyProps(),
    'Pause All Holds': (pauseUntil: DateOnlyIsoString) => ({pauseUntil}),
    'Pause All Holds Success': emptyProps(),
    'Pause All Holds Failure': (error: unknown) => ({error}),
    'Show Partially Paused Holds Confirmation': emptyProps()
  }
});
